module.exports = __webpack_public_path__ + "static/media/roundlogo.85bd2c7c.png";